import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export interface IssueCategory {
  id: number;
  name: string;
}

export interface IssueCategoriesResponse {
  status: string;
  data: IssueCategory[];
}

export default function useGetIssueCategories(
  handleOnSuccess?: (data: IssueCategoriesResponse) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation<IssueCategoriesResponse>({
    mutationFn: async () => {
      const response = await ChessRestClient.get(
        '/user_raised_issues/categories',
      );
      return response.data;
    },
    onSuccess: data => {
      if (handleOnSuccess) handleOnSuccess(data);
    },
    onError: error => {
      if (handleOnError) handleOnError(error);
    },
  });

  return mutation;
}
